import { take, put } from "redux-saga/effects"
import { LOGOUT } from "../actions/types"
import { setToken } from "../actions/creators"
import { redirectToLogoutPage } from "../helpers"

export default function* logoutSaga() {
  while (true) {
    yield take(LOGOUT)
    /* Delete current token */
    yield put(setToken(undefined))
    redirectToLogoutPage(true)
  }
}
